module.exports = __webpack_public_path__ + "img/delete-document.90c0435e.svg";